var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M100 51.262c0-14.137-4.886-26.215-14.658-36.234C75.57 5.009 63.789 0 50 0 36.21 0 24.43 5.01 14.658 15.028 4.886 25.047 0 37.125 0 51.262 0 62.728 3.312 72.97 9.935 81.986 15.58 89.222 28.935 102.078 50 120c21.064-17.922 34.42-30.778 40.065-38.014C96.688 72.97 100 62.728 100 51.262z","fill":"currentColor","fillRule":"evenodd"}));
}

Logo.defaultProps = {"viewBox":"0 0 100 120"};

module.exports = Logo;

Logo.default = Logo;
